<template>
  <header class="sticky-header">
    <!-- Header top -->
    <header-top-vue />

    <!-- Header bottom -->
    <template v-if="!secondLevelHeaderActive">
      <!-- Main header -->
      <div class="calc-new-header calc-appoitment">
        <div
          class="position-relative col-12-custom canel-add-icon text-center icon-nav-left"
        >
          <!-- Back button -->
          <div class="d-inline float-left" @click.stop.prevent="goBackToPrev">
            <a href="#" class="color-red">
              <object
                class="svg-back-arrow"
                :data="backSvg"
                type="image/svg+xml"
              ></object>
            </a>
          </div>

          <!-- Heading -->
          <div class="d-inline">
            <h5 class="mb-0 mt-0 sub-title-wrapper">Add Appointment</h5>
          </div>

          <!-- Add or Save button -->
          <div class="d-inline float-right" v-if="!hideBackAndAddButton">
            <a
              href="#"
              @click.prevent.stop="popup"
              class="color-red"
              v-if="getEdit.isEdit"
              >Save</a
            >
            <a
              v-show="addOption === ''"
              href="#"
              class="color-red d-inline cta-primary"
              @click.prevent.stop="submitForm"
              v-else
              >Add</a
            >
          </div>
        </div>
      </div>
    </template>

    <!-- Add toggles -->
    <template>
      <!-- Add person -->
      <transition name="drop">
        <add-person-toggle
          v-if="addOption === 'person'"
          :hide-drop-down="hideAddOption"
        />
      </transition>

      <!-- Add event -->
      <transition name="drop">
        <add-event-toggle
          v-show="addOption === 'event'"
          :hide-drop-down="hideAddOption"
        />
      </transition>

      <!-- Add group -->
      <transition name="drop">
        <add-group-toggle
          v-if="addOption === 'group'"
          :hide-drop-down="hideAddOption"
        />
      </transition>
    </template>
  </header>
</template>

<script>
import HeaderTopVue from "../../common/HeaderTop.vue";
import { addEditAppointmentHeaderMixin } from "../../../mixins/addEditAppointmentHeaderMixin";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AddAppointmentHeader",
  mixins: [addEditAppointmentHeaderMixin],
  props: {
    popup: Function, // Shows the popup
    addOption: String, // Which add option to show
    hideAddOption: Function // Hides the add option
  },
  data() {
    return {
      backSvg: require("../../../assets/svg/back.svg")
    };
  },
  computed: {
    ...mapGetters({
      getEdit: "getEdit",
      previousRoute: "getPreviousRoute",
      secondLevelHeaderActive: "getSecondLevelHeaderActive",
      hideBackAndAddButton: "getHideBackAndAddButton"
    })
  },
  methods: {
    ...mapActions({
      submitForm: "submitForm" // Function when form sumbit has been clicked
    }),
    goBackToPrev() {
      if (!("previousRoute" in this) || this.previousRoute === "/") {
        this.$router.push("/daily");
      } else {
        this.$router.go(-1);
      }
    }
  },
  components: {
    HeaderTopVue // The top part of the header
  }
};
</script>

<style scoped>
.daily-options-container {
  display: flex;
  justify-content: space-between;
  color: black;
}
.sub-title-wrapper {
  font-size: 18px;
  font-weight: normal;
  margin: 0px;
  line-height: 36px;
}

.header-icon-contain a.add-btn {
  margin-right: 100px !important;
}

.svg-back-arrow {
  top: 6px;
}

.daily-header-options.header {
  margin-top: 15px;
}

.daily-header-options.start-end {
  margin-top: 20px;
}

.d-inline.float-right {
  margin-right: 15px;
}
.text-center {
  text-align: center;
}
</style>
